// extracted by mini-css-extract-plugin
export default {"statusWithDescription":"rNMOzOTfPKTP_ub7X8tF","description":"zbJfvh8WNgFBQOmBC9YL"};